import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Compass, ExternalLink, ImageOff } from "lucide-react";

export default function Excursions() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("ebel_token");

  useEffect(() => {
    api.get("/excursions").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-10 py-16" data-testid="excursions-page">
      <div className="text-center mb-12">
        <p className="label-eyebrow mb-3">Rund um das Treffen</p>
        <h1 className="font-serif text-5xl lg:text-6xl tracking-tight">Ausflugsziele</h1>
        <p className="text-[#4A4F46] mt-4 max-w-2xl mx-auto leading-relaxed">
          Schöne Orte in der Umgebung, die sich für einen Ausflug lohnen.
        </p>
      </div>

      {loading && <p className="text-center text-[#4A4F46]">Lade …</p>}

      {!loading && items.length === 0 && (
        <div className="text-center py-20 border border-dashed border-[#E5DFD3] rounded-2xl">
          <Compass className="w-10 h-10 text-[#48634A] mx-auto mb-3" />
          <p className="font-serif text-2xl">Noch keine Ausflugsziele hinterlegt</p>
        </div>
      )}

      <div className="space-y-10">
        {items.map((it) => (
          <article
            key={it.id}
            className="bg-white border border-[#E5DFD3] rounded-2xl overflow-hidden shadow-[0_12px_40px_-25px_rgba(72,99,74,0.35)] grid md:grid-cols-2 gap-0"
            data-testid={`excursion-${it.id}`}
          >
            <ExcursionImages images={it.image_ids} token={token} name={it.name} />
            <div className="p-6 md:p-8 flex flex-col justify-center">
              <div className="flex items-center gap-2 text-[#3F7A42] mb-2">
                <Compass className="w-4 h-4" />
                <span className="label-eyebrow" style={{ color: "#3F7A42" }}>Ausflugsziel</span>
              </div>
              <h2 className="font-serif text-3xl lg:text-4xl tracking-tight text-[#1A1C19] leading-tight">{it.name}</h2>
              {it.description && (
                <p className="text-[#4A4F46] mt-4 leading-relaxed whitespace-pre-line">{it.description}</p>
              )}
              {it.website_url && (
                <a
                  href={it.website_url}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-5 inline-flex items-center gap-2 text-[#3F6E96] hover:text-[#2c5274] font-medium"
                  data-testid={`excursion-link-${it.id}`}
                >
                  <ExternalLink className="w-4 h-4" /> Zur Webseite
                </a>
              )}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

function ExcursionImages({ images, token, name }) {
  if (!images || images.length === 0) {
    return (
      <div className="bg-[#F4EFE6] aspect-[4/3] md:aspect-auto flex items-center justify-center text-[#48634A]/40">
        <ImageOff className="w-12 h-12" />
      </div>
    );
  }

  if (images.length === 1) {
    return (
      <div className="aspect-[4/3] md:aspect-auto bg-[#F4EFE6]">
        <img
          src={`${API}/photos/${images[0]}/download?auth=${token}`}
          alt={name}
          className="w-full h-full object-cover"
        />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-1 md:gap-0 aspect-[4/3] md:aspect-auto">
      {images.slice(0, 2).map((id) => (
        <div key={id} className="bg-[#F4EFE6] overflow-hidden">
          <img
            src={`${API}/photos/${id}/download?auth=${token}`}
            alt={name}
            className="w-full h-full object-cover"
          />
        </div>
      ))}
    </div>
  );
}
